import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import CompanyNumberField from './CompanyNumberField';
import React from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
export default function SelectNewCompanyTable(_ref) {
  let {
    showSetCompanyNumber = false,
    companies,
    onSelect,
    onSetCompanyNumber,
    user
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const getHeaderTranslation = () => {
    if (process.env.PUBLIC_URL === '/uk') {
      return 'Companies House Number';
    } else {
      return t('number');
    }
  };
  return /*#__PURE__*/React.createElement(Table, {
    className: "table table-hover"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-primary app-fs-table-header"
  }, /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Name"), showSetCompanyNumber && /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, getHeaderTranslation()), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, companies.map((company, index) => /*#__PURE__*/React.createElement("tr", {
    key: company.number
  }, /*#__PURE__*/React.createElement("td", null, company.name), showSetCompanyNumber && /*#__PURE__*/React.createElement(CompanyNumberField, {
    setCompanyNumber: onSetCompanyNumber,
    company: company,
    index: index
  }), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "sm",
    onClick: () => onSelect(company, history, user)
  }, "Select ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right")))))));
}